export default __webpack_public_path__ + "static/media/telephone.4da974d2.svg";